export default "__VITE_ASSET__DHlm48l2__"